export default {
  index: [
    {
      path: '/teapinpai',
      component: resolve => require(['./commodityppIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/commoditypp/_router.js